import { _ } from '../utils.js'
import Bugsnag from '@bugsnag/js'
import { isBrowserSupported } from '../utils/browser-support.js'
import config from '../config/main.js'

export default () => {
    const env = _('site-info', 'element').node()
    const environment = env?.dataset.environment ?? process.env.NODE_ENV
    const isLocal = environment === 'development' || environment === 'local'
    const loggedIntoCMS = env?.dataset.c5 === 'true' ? true : false
    if (isLocal || !isBrowserSupported() || loggedIntoCMS) {
        return false
    }
    if (config.bugsnagKey === 'apiKeyNeeded') {
        console.warn(
            'Bugsnag API key is missing. Please add it to the config file.',
        )
        return false
    }
    Bugsnag.start({
        apiKey: config.bugsnagKey,
        enabledReleaseStages: ['staging', 'production', 'styleguide'],
        releaseStage: environment,
        appVersion: config.version,
    })

    // Bugsnag.notify(new Error('UI testing, safe to mark as fixed'))
}
